import { MantineProvider } from '@mantine/core';
import type { ReactNode } from 'react';

type Props = {
  children: ReactNode;
};
export const ThemeProvider = ({ children }: Props) => (
  <MantineProvider
    theme={{
      colorScheme: 'dark',
      // Prevent mobile browser auto-zoom on input focus
      // Mobile browsers zoom when input font-size < 16px
      components: {
        Input: {
          styles: {
            input: {
              fontSize: '16px',
            },
          },
        },
        MultiSelect: {
          styles: {
            input: {
              fontSize: '16px',
            },
          },
        },
      },
    }}
    withGlobalStyles
    withNormalizeCSS
  >
    {children}
  </MantineProvider>
);
